export const enum EnrollmentTypeCode{
    NewService= 'TURNON',
    SwitchService= 'SWITCH',
    Standard = 'STANDARD'
}